<template>
  <div id="app" class="admin-layout">
    <RouterView />
    <Toast position="top-right" />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { provide, computed } from 'vue'
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { THEME_CONFIG_KEY, SITE_CONFIG_KEY } from '@aannemerplus/shared-components'

// Default admin configuration for shared components
const defaultThemeConfig = computed(() => 'aura' as const)

const defaultSiteConfig = computed(() => ({
  name: 'Admin Panel',
  description: 'AannemerPlus Admin Interface',
  url: window.location.origin + (import.meta.env.BASE_URL || '/'),
  defaultTheme: 'aura' as const,
}))

// Provide configuration context for shared components
provide(THEME_CONFIG_KEY, defaultThemeConfig)
provide(SITE_CONFIG_KEY, defaultSiteConfig)
</script>

<style scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>